// generate unique id similar to mongoDB id
// source website: https://observablehq.com/@hugodf/mongodb-objectid-generator
// source github gist: https://gist.github.com/solenoid/1372386
export const uid = function () {
    const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
};